
import { Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { usePlanillassStore } from '../../../../store';



export const FormCantidadAndDestares = ({ onCahnge }) => {



    const { items, updateItemField, removeItem, formValues } = usePlanillassStore();


    // const removeRow = (id) => {
    //     setItems( items.filter((row) => row.id !== id) );
    // };



    // const cambiarNHuacales = (e, id) => {
    //     const newCantidad = e.target.value;
    //     const cantidaActual = items.map(( p ) => {
    //         if( p.id === id ){
    //             p = { ...p, huacales: newCantidad }
    //         }
    //         return p;
    //     });
    //     setItems(cantidaActual);
    // }


    // const cambiarAvesXHuacal = (e, id) => {
    //     const newCantidad = e.target.value;
    //     const cantidaActual = items.map(( p ) => {
    //         if( p.id === id ){
    //             p = { ...p, avesXhuacal: newCantidad }
    //         }
    //         return p;
    //     });
    //     setItems(cantidaActual);
    // }


    // const cambiarPesoAvesH = (e, id) => {
    //     const newCantidad = e.target.value;
    //     const cantidaActual = items.map(( p ) => {
    //         if( p.id === id ){
    //             p = { ...p, pesoAvesHuacal: newCantidad }
    //         }
    //         return p;
    //     });
    //     setItems(cantidaActual);
    // }


    // const cambiarDestare = (e, id) => {
    //     const newCantidad = e.target.value;
    //     const cantidaActual = items.map(( p ) => {
    //         if( p.id === id ){
    //             p = { ...p, destare: newCantidad }
    //         }
    //         return p;
    //     });
    //     setItems(cantidaActual);
    // }




    return (

        <>
        <Grid item xs={12} sm={6}>
            <TextField
                size='small'
                label="Tipo de Descuento"
                fullWidth
                disabled
                name='descuento'
                value={formValues.descuento}
            >    
            </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
            <TextField 
                size='small'
                label="Cantidad Total"
                fullWidth
                type="number"
                placeholder='Cantidad Total'
                name='cantidad'
                value={formValues.cantidad}
                onChange={ onCahnge }
            >
            </TextField>
        </Grid>


        <Grid item xs={12} sx={{px:0}}>
            <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto'}}>
                <TableContainer >
                    <Table sx={{minWidth:700, overflowX:'auto'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'5%'}}>#</TableCell>
                                <TableCell sx={{width:'25%'}}>N° Huacales</TableCell>
                                <TableCell sx={{width:'25%'}}>Aves x Huacal</TableCell>
                                <TableCell sx={{width:'25%'}}>Peso Aves x Huacal</TableCell>
                                <TableCell sx={{width:'15%'}}>Destare</TableCell>
                                <TableCell sx={{width:'5%'}}>A.</TableCell>
                            </TableRow>
                        </TableHead>

                    {(items.length > 0) 
                    ?   <TableBody>
                            {items.map((row, index) => (
                            <TableRow key={row._id}>
                                <TableCell>{ index + 1 }</TableCell>
                                <TableCell>
                                    <TextField size='small' 
                                        label="N° Huacales"
                                        fullWidth
                                        type="number"
                                        placeholder='N° Huacales'
                                        name='huacales'
                                        value={row.huacales}
                                        // onChange={ (e) => cambiarNHuacales(e, row.id) }
                                        onChange={(e) => updateItemField(row._id, 'huacales', e.target.value)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Uni.</InputAdornment>,
                                        }}
                                    >
                                    </TextField>
                                </TableCell>

                                <TableCell>
                                    <TextField size='small'
                                        label="Aves X Huacal"
                                        fullWidth
                                        type="number"
                                        placeholder='Aves X Huacal'
                                        name='avesXhuacal'
                                        value={row.avesXhuacal}
                                        // onChange={ (e) => cambiarAvesXHuacal(e, row.id) }
                                        onChange={(e) => updateItemField(row._id, 'avesXhuacal', e.target.value)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Uni.</InputAdornment>,
                                        }}
                                    >
                                    </TextField>
                                </TableCell>

                                <TableCell>
                                    <TextField size='small'
                                        label="Peso Aves X Huacal"
                                        fullWidth
                                        placeholder='Peso Aves X Huacal'
                                        name='pesoAvesHuacal'
                                        value={row.pesoAvesHuacal}
                                        // onChange={ (e) => cambiarPesoAvesH(e, row.id) }
                                        onChange={(e) => updateItemField(row._id, 'pesoAvesHuacal', e.target.value)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                                        }}
                                    >
                                    </TextField>
                                </TableCell>

                                <TableCell>
                                    <TextField size='small'
                                        label="Destare"
                                        fullWidth
                                        type="number"
                                        placeholder='Destare'
                                        name='destare'
                                        value={row.destare}
                                        // onChange={ (e) => cambiarDestare(e, row.id) }
                                        onChange={(e) => updateItemField(row._id, 'destare', e.target.value)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                                        }}
                                    >
                                    </TextField>
                                </TableCell>


                                <TableCell>
                                    <IconButton className="icon-boton" onClick={ () => removeItem(row._id) }>
                                        <Delete fontSize="small" color='error' />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>

                    :   <TableBody><TableRow>
                            <TableCell sx={{py:3}} align="center" colSpan={7}>
                                <Typography variant='h3'>Agregue Items Por Favor</Typography>
                            </TableCell>
                        </TableRow></TableBody>

                    }
                    </Table>
                </TableContainer>
            </Paper>
        </Grid>













        </>

    )
}
